import { render, staticRenderFns } from "./AprovacaoSolicitacaoDetalhesProdutoModalView.vue?vue&type=template&id=703db782&"
import script from "./AprovacaoSolicitacaoDetalhesProdutoModalView.vue?vue&type=script&lang=js&"
export * from "./AprovacaoSolicitacaoDetalhesProdutoModalView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
